/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'search': {
    width: 54.666,
    height: 58.667,
    viewBox: '0 0 569 611',
    data: '<path pid="0" d="M564 578L399 406c42-42 68-100 68-165C467 112 362 8 234 8 105 8 1 113 1 241c0 129 105 233 233 233 56 0 108-20 149-54l165 172c2 2 5 3 8 3s6-1 8-3c4-4 5-11 0-16zM234 453c-116 0-211-95-211-211S118 31 234 31s211 95 211 211-95 211-211 211z" fill-rule="nonzero"/>'
  }
})
